import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromBulkAdd from './reducers/bulk-add/product-list-bulk-add.reducer';
import * as fromCreateList from './reducers/create-list/create-list.reducer';
import * as fromListOpened from './reducers/list-opened/product-list-opened.reducer';
import * as fromLists from './reducers/lists/product-lists.reducer';

export const productListFeatureKey = 'product-lists';

export interface ProductListState {
  [fromBulkAdd.productListBulkAddFeatureKey]: fromBulkAdd.State;
  [fromCreateList.createListFeatureKey]: fromCreateList.State;
  [fromListOpened.productListOpenedFeatureKey]: fromListOpened.State;
  [fromLists.productListsFeatureKey]: fromLists.State;
}

export interface State {
  [productListFeatureKey]: ProductListState;
}

export const initialState: ProductListState = {
  [fromBulkAdd.productListBulkAddFeatureKey]: fromBulkAdd.initialState,
  [fromCreateList.createListFeatureKey]: fromCreateList.initialState,
  [fromListOpened.productListOpenedFeatureKey]: fromListOpened.initialState,
  [fromLists.productListsFeatureKey]: fromLists.initialState,
};

/** Provide reducer in AoT-compilation happy way */
export function reducers(state: ProductListState | undefined, action: Action) {
  return combineReducers({
    [fromLists.productListsFeatureKey]: fromLists.reducer,
    [fromListOpened.productListOpenedFeatureKey]: fromListOpened.reducer,
    [fromBulkAdd.productListBulkAddFeatureKey]: fromBulkAdd.reducer,
    [fromCreateList.createListFeatureKey]: fromCreateList.reducer,
  })(state, action);
}

export const selectProductListState = createFeatureSelector<ProductListState>(
  productListFeatureKey,
);
